import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Alert from '../../../components/Alert/Alert';
import Button from '../../../components/Button/Button';
import ButtonGroup from '../../../components/ButtonGroup/ButtonGroup';
import Table from '../../../components/Table/Table';
import { RootState } from '../../../stores/Store';

import useImportErrorsStep from './useImportErrorsStep';

export interface ImportErrorsStepProps {
  onClose: () => void;
}

function ImportErrorsStep({ onClose }: ImportErrorsStepProps) {
  const [t] = useTranslation();
  const { rows, headers, isLoading, confirmDuplicatedFileImport } = useImportErrorsStep();
  const { importResponse } = useSelector((state: RootState) => state.importReducer);

  /**
   * Submit button handler
   * Performs the confirm import
   */
  const submitHandler = () => {
    if (importResponse) {
      confirmDuplicatedFileImport(importResponse.uploadType, importResponse.uploadId, onClose);
    }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Alert alertType="error" message={t('pages.import.importFailedTitle')} />
      <Typography sx={{ marginTop: '2.5rem', marginBottom: '1rem' }}>
        {t('pages.import.importFailedDescription')}
      </Typography>
      {/* Table */}
      <Table rows={rows} headers={headers} />
      <Typography sx={{ marginTop: '2.5rem', marginBottom: '1rem' }}>{t('pages.import.pleaseCorrect')}</Typography>
      {/* Buttons */}
      <Box sx={{ marginTop: 'auto' }}>
        <ButtonGroup>
          <Button label={t('common.back')} color="alternative2Button" onClick={onClose} />
          <Button
            label={t('pages.import.excludeProceed')}
            color="primaryButton"
            disabled={isLoading || importResponse?.successfulLines === 0}
            onClick={submitHandler}
          />
        </ButtonGroup>
      </Box>
    </Box>
  );
}

export default ImportErrorsStep;
